import React, { useState, useContext } from "react";
import Header from "../Header";
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, 
  TextField, Paper, Box, Button, Typography } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useParams, useNavigate } from "react-router-dom";
import { AppContext } from "../../App";
import HelpIcon from '@mui/icons-material/Help';

export default function Login() {

  const { setActiveUser } = useContext(AppContext)

  const [login, setLogin] = useState({
    username: "",
    password: "",
    showPassword: false
  })

  const params = useParams()
  const navigate = useNavigate()

  async function checkLogin(e){
    e.preventDefault()

    const response = await fetch(`https://the-paper-pusher.herokuapp.com/checkLogin/${login.username}`)
    if (!response.ok) {
      const message = `An error occurred: ${response.statusText}`
      window.alert(message)
      return
    }

    const activeUser = await response.json()
    if(activeUser.adminDetails.password === login.password){
      console.log("password is correct")
      navigate("/admin")
    } else if (activeUser.adminDetails.password != login.password){
      console.log("password is incorrect")
    }
    console.log(activeUser)
    setActiveUser(activeUser)
    localStorage.setItem("user", activeUser.username)
  }

  const handleChange = (e) => {
    setLogin(
      { ...login, 
        [e.target.name]: e.target.value 
      });
  };

  const handleClickShowPassword = () => {
    setLogin({
      ...login,
      showPassword: !login.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div className="register-form">
      <Header />
      <div className="login-container">
        <Paper elevation={3} sx={{maxWidth: 620, margin: '0 auto', borderRadius: '1.5em'}}>
          <h3 className="form-heading">Log in</h3>
          <Typography sx={{margin: '0 auto', marginBottom: '1em', maxWidth: 300, border: '1px solid black', borderRadius: '0.5em', padding: '0.3em'}}>Use username: <strong>demo</strong> & password: <strong>demo123</strong> to poke around...</Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', maxWidth: 700, margin: '0 auto' , justifyContent: 'center'}}>

          <div className="register-inputs">
            <TextField
              required
              sx={{marginBottom: 2}}
              name="username"
              id="outlined-required"
              label="Username"
              onChange={handleChange}
              />


          <FormControl sx={{marginBottom: 2}} variant="outlined">
            <InputLabel required htmlFor="outlined-adornment-password">Password</InputLabel>
            <OutlinedInput
              name="password"
              id="outlined-adornment-password"
              type={login.showPassword ? 'text' : 'password'}
              value={login.password}
              onChange={handleChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {login.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
            />
          </FormControl>

          </div>

          </Box>

          <Button onClick={checkLogin}>Login</Button>
          
          <div className="already-register">
            <Typography>
              Don't have an account yet? 
              <Button onClick={() => navigate("/register")}>Register</Button>
            </Typography>
            <IconButton onClick={()=> navigate("/help")}><HelpIcon /><Typography sx={{marginLeft: '0.5em'}}>Learn more</Typography></IconButton>
            {/* <Typography>
              Are you a promoter? 
              <Button onClick={() => navigate("/promoter")}>Click here</Button>
            </Typography> */}
          </div>
          

        </Paper>
      </div>
      
    </div>
  ) 
}